import { render, staticRenderFns } from "./ListProviders.vue?vue&type=template&id=1af3515a"
import script from "./ListProviders.vue?vue&type=script&lang=js"
export * from "./ListProviders.vue?vue&type=script&lang=js"
import style0 from "./ListProviders.vue?vue&type=style&index=0&id=1af3515a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports